"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    presenceAwayRegular: function() {
        return presenceAwayRegular;
    },
    presenceAwayFilled: function() {
        return presenceAwayFilled;
    },
    presenceAvailableRegular: function() {
        return presenceAvailableRegular;
    },
    presenceAvailableFilled: function() {
        return presenceAvailableFilled;
    },
    presenceBlockedRegular: function() {
        return presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return presenceBusyFilled;
    },
    presenceDndFilled: function() {
        return presenceDndFilled;
    },
    presenceDndRegular: function() {
        return presenceDndRegular;
    },
    presenceOofRegular: function() {
        return presenceOofRegular;
    },
    presenceOfflineRegular: function() {
        return presenceOfflineRegular;
    },
    presenceUnknownRegular: function() {
        return presenceUnknownRegular;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reacticons = require("@fluentui/react-icons");
const presenceAwayRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceAway10Regular,
    'extra-small': _reacticons.PresenceAway10Regular,
    small: _reacticons.PresenceAway12Regular,
    medium: _reacticons.PresenceAway16Regular,
    large: _reacticons.PresenceAway20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceAway20Regular
};
const presenceAwayFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceAway10Filled,
    'extra-small': _reacticons.PresenceAway10Filled,
    small: _reacticons.PresenceAway12Filled,
    medium: _reacticons.PresenceAway16Filled,
    large: _reacticons.PresenceAway20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceAway20Filled
};
const presenceAvailableRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceAvailable10Regular,
    'extra-small': _reacticons.PresenceAvailable10Regular,
    small: _reacticons.PresenceAvailable12Regular,
    medium: _reacticons.PresenceAvailable16Regular,
    large: _reacticons.PresenceAvailable20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceAvailable20Regular
};
const presenceAvailableFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceAvailable10Filled,
    'extra-small': _reacticons.PresenceAvailable10Filled,
    small: _reacticons.PresenceAvailable12Filled,
    medium: _reacticons.PresenceAvailable16Filled,
    large: _reacticons.PresenceAvailable20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceAvailable20Filled
};
const presenceBlockedRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceBlocked10Regular,
    'extra-small': _reacticons.PresenceBlocked10Regular,
    small: _reacticons.PresenceBlocked12Regular,
    medium: _reacticons.PresenceBlocked16Regular,
    large: _reacticons.PresenceBlocked20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceBlocked20Regular
};
const presenceBusyFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceBusy10Filled,
    'extra-small': _reacticons.PresenceBusy10Filled,
    small: _reacticons.PresenceBusy12Filled,
    medium: _reacticons.PresenceBusy16Filled,
    large: _reacticons.PresenceBusy20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceBusy20Filled
};
const presenceDndFilled = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceDnd10Filled,
    'extra-small': _reacticons.PresenceDnd10Filled,
    small: _reacticons.PresenceDnd12Filled,
    medium: _reacticons.PresenceDnd16Filled,
    large: _reacticons.PresenceDnd20Filled,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceDnd20Filled
};
const presenceDndRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceDnd10Regular,
    'extra-small': _reacticons.PresenceDnd10Regular,
    small: _reacticons.PresenceDnd12Regular,
    medium: _reacticons.PresenceDnd16Regular,
    large: _reacticons.PresenceDnd20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceDnd20Regular
};
const presenceOofRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceOof10Regular,
    'extra-small': _reacticons.PresenceOof10Regular,
    small: _reacticons.PresenceOof12Regular,
    medium: _reacticons.PresenceOof16Regular,
    large: _reacticons.PresenceOof20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceOof20Regular
};
const presenceOfflineRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceOffline10Regular,
    'extra-small': _reacticons.PresenceOffline10Regular,
    small: _reacticons.PresenceOffline12Regular,
    medium: _reacticons.PresenceOffline16Regular,
    large: _reacticons.PresenceOffline20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceOffline20Regular
};
const presenceUnknownRegular = {
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    tiny: _reacticons.PresenceUnknown10Regular,
    'extra-small': _reacticons.PresenceUnknown10Regular,
    small: _reacticons.PresenceUnknown12Regular,
    medium: _reacticons.PresenceUnknown16Regular,
    large: _reacticons.PresenceUnknown20Regular,
    // FIXME not all presence icon sizes are available
    // https://github.com/microsoft/fluentui/issues/20650
    'extra-large': _reacticons.PresenceUnknown20Regular
};
